/** Shared GraphQL fields for trust marker entries. */
export const TRUST_MARKER_FIELDS = `
  sys { id }
  id
  link
  alt
  rating
  totalReview
  letterGrade
  lastTimeVerified
  image { url title width height contentType }
  logo { url title width height contentType }
`

export const TRUST_MARKERS_COMBINATION_FIELDS = `
  sys { id }
  id
  trustMarkerCollection(limit: 20) {
    items { ${TRUST_MARKER_FIELDS} }
  }
`
